import logo from '@/images/BitNinja T.png';
import favicon from '@/images/Fevicon T.png';

export const brandAssets = {
  logo,
  favicon,
} as const;

/** Visual treatment when the logo sits on a dark background. */
export type LogoVariant = 'light' | 'dark';

/** Routes whose hero section uses a dark background (navbar sits over dark when not scrolled). */
export const darkHeroRoutes = ['/services', '/surat', '/san-francisco'];

export function usesDarkHero(pathname: string): boolean {
  return darkHeroRoutes.some((route) => pathname.startsWith(route));
}

export function resolveLogoVariant(pathname: string, isScrolled: boolean): LogoVariant {
  if (isScrolled) return 'light';
  return usesDarkHero(pathname) ? 'dark' : 'light';
}

export function setFavicon() {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = 'image/png';
  link.href = brandAssets.favicon;
}
